<template>
  <div class="add-address flex-page">
    <van-nav-bar
      @click-right="deleteInfo"
      left-arrow
      :title="title"
      :right-text="addrId && '删除'"
      @click-left="onBack"
    ></van-nav-bar>
    <van-field label="收货人" v-model="info.name" placeholder="请输入收货人姓名" maxlength="25" />
    <van-field
      label="手机号码"
      type="tel"
      v-model="info.mobile"
      placeholder="请输入"
      @blur="checkPhone"
      maxlength="11"
      clearable
    />
    <van-field
      label="所在地区"
      :value="info.regionList.map(item=> item.text).join(' ')"
      placeholder="请选择"
      readonly
      isLink
      @click="handlePicker"
    />
    <van-field
      label="详细地址"
      v-model="info.address"
      type="textarea"
      placeholder="请输入"
      maxlength="70"
      :show-word-limit="true"
      rows="1"
      autosize
      clearable
    />
    <van-cell title="设置为默认地址" class="add-address__default">
      <van-switch v-model="defaultFlag" slot="default"></van-switch>
    </van-cell>
    <div class="add-address__confirm-button">
      <van-button block @click="addAddress" type="primary">确定</van-button>
    </div>

    <van-dialog v-model="show" title="信息未保存" show-cancel-button @confirm="$router.go(-1)">
      <p class="description">返回后修改的信息不被保存，确定返回吗？</p>
    </van-dialog>

    <van-popup v-model="chooseArea" position="bottom" get-container="body">
      <!-- <van-area title="所在地区" :area-list="areaList" @cancel="chooseArea = false" @confirm="onConfirm" :value="areaValue" /> -->
      <van-picker show-toolbar title="所在地区" :columns="areaList" ref="addrPicker" @cancel="chooseArea = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
// import area from './area';
import Vue from 'vue';
import { mapState } from 'vuex';
import { NavBar } from '@zyf2e/capui-mobile';

Vue.use(NavBar);

const toString = (val) => {
  return (val && String(val)) || '';
};

const defaultData = {
  address: '',
  name: '',
  mobile: '',
  regionList: [],
  defaultFlag: false
};

export default {
  computed: {
    ...mapState('address', ['addressInfo']),
    addrId() {
      return this.$route.query.addrId || '';
    }
  },
  data() {
    return {
      chooseArea: false,
      areaValue: '',
      areaList: [],

      // columns:  [
      //   {
      //     text: '浙江',
      //     value: '1',
      //     children: [
      //       {
      //         text: '杭州',
      //         value: '11',
      //         children: [{ text: '西湖区', value: '111', }, { text: '余杭区', value: '111', }],
      //       },
      //       {
      //         text: '温州',
      //         value: '12',
      //         children: [{ text: '鹿城区', value: '121' }, { text: '瓯海区', value: '123' }],
      //       },
      //     ],
      //   },
      //   {
      //     text: '福建',
      //     children: [
      //       {
      //         text: '福州',
      //         children: [{ text: '鼓楼区' }, { text: '台江区' }],
      //       },
      //       {
      //         text: '厦门',
      //         children: [{ text: '思明区' }, { text: '海沧区' }],
      //       },
      //     ],
      //   },
      // ],

      show: false,

      active: 0,

      list: [],

      oldInfo: { ...defaultData },

      info: { ...defaultData },

      title: '新增地址',

      defaultFlag: false
    };
  },

  async created() {
    this.$fetch.getAllAreaList().then(res=> {
      this.areaList = res
    })
  
  

    const { name, mobile, province, city, region, provinceCode, cityCode, regionCode, address, defaultFlag } = this.$route.query;
    this.defaultFlag = defaultFlag === '1';
    this.areaValue = regionCode || ''
    if (this.addrId) {
      this.title = '编辑地址';
      this.info = {
        address: toString(address),
        name: toString(name),
        mobile: toString(mobile),
        regionList: [{value: provinceCode, text: province}, {value:cityCode, text:city  }, {value: regionCode, text: region}],
        defaultFlag: this.defaultFlag
      };

      this.oldInfo = {
        ...this.info
      };
    }
  },
  methods: {
    checkPhone() {
      if (this.info.mobile && !this.$util.isMobileNumValid(this.info.mobile)) {
        this.$toast('手机号码格式不正确');
      }
    },

    async deleteInfo() {
      try {
        const addressId = Number(this.addrId);

        await this.$dialog.confirm({ title: '温馨提示', message: '确认删除该地址？' });
        await this.$fetch.deleteAddressAction({
          addressId
        });
        this.$toast('删除成功 ');
        if (addressId === this.addressInfo.addrId) {
          this.$store.commit('address/setAddressInfo', {});
        }

        setTimeout(() => {
          this.$router.go(-1);
          // this.adapter.goBack();
        }, 1500);
      } catch (error) {
        // do nothing
      }
    },
    handlePicker() {
      this.chooseArea = true
      this.$nextTick(()=> {
        if (this.$refs.addrPicker) this.$refs.addrPicker.setValues(this.info.regionList.map(item => item.text))
      })
    },

    onConfirm(val) {
      
      if (!val.includes('请选择')) {
        this.info.regionList = this.$refs.addrPicker.getValues().map(item =>{
          delete item.children 
          return item
        });
        console.log(this.info.regionList)
        
        this.chooseArea = false;
      } else {
        this.$toast('请选择所在地区');
      }
    },

    async addAddress() {
      if (this.info.mobile && !this.$util.isMobileNumValid(this.info.mobile)) {
        this.$toast('手机号码格式不正确');
        return false
      }
      if (Object.values(this.info).some((x) => x.length === 0)) {
        this.$toast('请将信息填写完整');
        return fals
      }
      const { regionList } = this.info;
      

      const data = {
        ...this.info,
        province: toString(regionList[0]?.text),
        city: toString(regionList[1]?.text),
        region: toString(regionList[2]?.text),
        provinceCode: toString(regionList[0]?.value),
        cityCode: toString(regionList[1]?.value),
        regionCode: toString(regionList[2]?.value),
        zipcode: '',
        defaultFlag: this.defaultFlag ? 1 : 0
      };


      let result;
      if (this.addrId) {
        result = await this.$fetch.updateAddressAction({
          ...data,
          addrId: Number(this.addrId)
        });
      } else {
        result = await this.$fetch.addAddressAction(data);
      }

      if (result) {
        this.$router.go(-1);
        // this.adapter.goBack();
      }
      const str = result ? '成功' : '失败';
      this.$toast(`${this.addrId ? '更新' : '新增'}${str}`);
    },

    onBack() {
      const keys = Object.keys(defaultData);
      this.show = keys.some((val) => this.info[val] !== this.oldInfo[val]);
      if (!this.show) {
        this.$router.go(-1);
        // this.adapter.goBack();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.add-address {
  /deep/.title-auto {
    width: 92px;
  }
  /deep/.van-cell__title {
    font-size: @font-size-lg;
  }
  /deep/.van-field__control {
    font-size: @font-size-lg;
    color: @gray-7;
  }
  /deep/.van-cell__title,
  .van-field__label {
    width: 74px;
  }

  .description {
    color: #999;
    font-size: @font-size-sm;
    padding: 11px 28px;
    text-align: center;
  }
  &__default {
    margin-top: 10px;
    /deep/.van-cell__value {
      overflow: initial;
      height: 24px;
    }
  }
  &__confirm-button {
    margin: 20px 12px 0;
    border-radius: 4px;
    background: @green;
    color: @white;
    font-size: @font-size-lg;
  }
}
</style>
